import React, { useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { Grid, Color, Shadow } from '../../../app/StyleGuide';
import { Button, DangerButton } from '../../../components/Buttons';
import windowService from '../../../services/windowService';
import { UrlParams } from '../models/url';
import { getTrainingOverview, ActiveCourseOverview, ActivePathwayOverview } from '../../training';
import { useUser } from '../../authentication';
import { unassignTraining } from '../api/unassignTraining';
import alertService from '../../../services/AlertService';

type ActiveTraining = ActiveCourseOverview | ActivePathwayOverview;

const SectionHeader = styled.h3`
  border-bottom: 1px solid ${Color.Gray._20};
  padding-bottom: ${Grid._2};
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${Grid._4};
  padding: ${Grid._2} ${Grid._4} ${Grid._6} ${Grid._4};
  background: ${Color.white};
  box-shadow: ${Shadow.medium};
`;

type Props = {
  canAssign: boolean;
  isPublished: boolean;
  onEasyLinkClick: () => void;
  onUnpublishClick: () => void;
};

export const ActionsContainer = ({ canAssign, isPublished, onEasyLinkClick, onUnpublishClick }: Props) => {
  const { trainingId } = useParams<UrlParams>();
  const { user } = useUser();
  const [assignToYourselfLoading, setAssignToYourselfLoading] = useState(false);

  const handleAssignToYourself = () => {
    setAssignToYourselfLoading(true);
    getTrainingOverview(user?.userId || '', false).then((training: ActiveTraining[]) => {
      const existingSelfAssignedTraining = training.find(
        training => training.originalTrainingId === trainingId && training.selfAssigned
      );
      if (existingSelfAssignedTraining) {
        unassignTraining(
          trainingId,
          existingSelfAssignedTraining._type === 'ActiveCourseOverview' ? 'TaskList' : 'Workflow',
          user?.userId || ''
        );
      }
      localStorage.setItem('routeBeforeSteps', window.location.hash);
      localStorage.setItem('unAssignOnBack', 'true');
      alertService.showOnNextPage('Added To Your Dashboard');
      return windowService.redirectTo(`/add-to-your-training/${trainingId}`);
    });
    setAssignToYourselfLoading(false);
  };

  return canAssign ? (
    <div>
      <Container>
        <SectionHeader>Assignment Actions</SectionHeader>
        <Button onClick={onEasyLinkClick}>Assign by Easy Link</Button>
        <Button onClick={() => windowService.redirectTo(`/assign-training/${trainingId}`)}>Assign by Email</Button>
        <Button
          onClick={handleAssignToYourself}
          disabled={assignToYourselfLoading}
          submitting={assignToYourselfLoading}
        >
          Assign to Yourself
        </Button>

        {isPublished && (
          <>
            <SectionHeader>Publishing Actions</SectionHeader>
            <DangerButton onClick={onUnpublishClick}>Unpublish</DangerButton>
          </>
        )}
      </Container>
    </div>
  ) : null;
};
